import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";
import Helmet from "react-helmet";
import styled from "styled-components";

import ReadParameterGroup from "./ReadParameterGroup.graphql";

const StyledHeaderContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-bottom: 16px;
    border-bottom: 1px solid #ebecf0;
    margin-bottom: 16px;

    .title-row {
        align-items: center;
        display: flex;
        gap: 12px;
        justify-content: space-between;
    }

    h1 {
        color: #172b4d;
        font-size: 1.35rem;
        font-weight: 700;
        letter-spacing: -0.01em;
        margin: 0;
    }
`;

export default function ParameterGroupTitle(props) {
    const { id } = props;

    const readParameterGroup = useQuery(
        gql(ReadParameterGroup),
        {
            variables: {
                id,
            },
        },
    );

    if (readParameterGroup.loading) return "loading";
    if (readParameterGroup.error) return "error";

    const nameText = readParameterGroup.data.parameterGroup.name[0]?.text ?? "Untitled Parameter Group";

    return (
        <StyledHeaderContainer>
            <Helmet>
                <title>PG - { nameText } - taxonomy</title>
            </Helmet>
            <div className="title-row">
                <h1>{ nameText }</h1>
            </div>
        </StyledHeaderContainer>
    );
}
